// extracted by mini-css-extract-plugin
export default {"video-js":"Player_video-js__pLjeX","vjs-tech":"Player_vjs-tech__lKZRB"};